import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigInterceptor } from './config.interceptor';
import { ErrorInterceptor } from '@core/interceptors/error.interceptor';

export const INTERCEPTORS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ConfigInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
  },
]
